import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { toast } from "sonner";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", jenjang: "S1", university: "" });
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Akun dibuat! Selamat datang.");
      nav("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Registrasi gagal");
    } finally { setBusy(false); }
  };

  const google = () => {
    const redirect = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const set = (k, v) => setForm({ ...form, [k]: v });

  return (
    <div className="min-h-screen kt-gradient-hero flex items-center justify-center p-6">
      <div className="w-full max-w-md kt-card p-8">
        <Link to="/" className="flex justify-center mb-4">
          <img src="https://customer-assets-v7afamib.emergentagent.net/job_thesis-mate/artifacts/l29gu6p6_Untitled%20design%20%283%29.png" alt="kawantugas.id" className="h-20 w-auto" />
        </Link>
        <h1 className="serif text-3xl font-bold text-[#0F2922] mb-1">Daftar Gratis</h1>
        <p className="text-sm text-slate-600 mb-6">Buka akses semua fitur akademik.</p>

        <Button variant="outline" className="w-full mb-4 border-slate-300" onClick={google} data-testid="register-google-button">Daftar dengan Google</Button>
        <div className="text-xs text-center text-slate-400 mb-4">atau isi form</div>

        <form onSubmit={submit} className="space-y-3">
          <div><Label>Nama lengkap</Label><Input required value={form.name} onChange={e=>set("name", e.target.value)} data-testid="register-name-input" /></div>
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={e=>set("email", e.target.value)} data-testid="register-email-input" /></div>
          <div><Label>Password (min 6 karakter)</Label><Input type="password" required minLength={6} value={form.password} onChange={e=>set("password", e.target.value)} data-testid="register-password-input" /></div>
          <div>
            <Label>Jenjang studi</Label>
            <Select value={form.jenjang} onValueChange={(v)=>set("jenjang", v)}>
              <SelectTrigger data-testid="register-jenjang-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="S1">S1 (Sarjana)</SelectItem>
                <SelectItem value="S2">S2 (Magister)</SelectItem>
                <SelectItem value="S3">S3 (Doktor)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>Universitas (opsional)</Label><Input value={form.university} onChange={e=>set("university", e.target.value)} data-testid="register-university-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-[#0F2922] hover:bg-[#173E34] text-[#FAFA96]" data-testid="register-submit-button">
            {busy ? "Memuat…" : "Buat akun"}
          </Button>
        </form>
        <p className="mt-4 text-sm text-center text-slate-600">Sudah punya akun? <Link to="/login" className="text-[#D97706] font-semibold">Masuk</Link></p>
      </div>
    </div>
  );
}
